'use client';

import { Dialog, IconButton, theme, ThemeProvider } from '@frameio/vapor';
import { IconX } from '@frameio/vapor-icons';
import styles from './AccountLockingDialog.module.css';
import { AccountLockingDialogContent } from './AccountLockingDialogContent';
import TEXT from './generated/TEXT/AccountLockingDialog';

TEXT.DEFINE({
  /** Aria label - changes based on whether viewing a share or locked account */
  ariaLabel: (isShare: boolean): string =>
    isShare ? 'This Share is Unavailable' : 'Your account is locked',
  /** Close button label */
  iconLabel: 'close',
});

type AccountLockingDialogProps = {
  isShare: boolean;
  isShowing: boolean;
  isForcedLock: boolean;
  onClose: () => void;
};

/**
 * This Dialog can not be dismissed by a user.
 * Instead the Dialog is dismissed when a user initiates
 * a route change via the Dialog actions.
 */
export const AccountLockingDialog = ({
  isShowing = false,
  isShare,
  isForcedLock,
  onClose,
}: AccountLockingDialogProps) => {
  return (
    <ThemeProvider brand="fio">
      <Dialog
        aria-labelledby={TEXT.ariaLabel(isShare)}
        isShowing={isShowing}
        onRequestClose={onClose}
        zIndex={theme.zIndices.tooltip + 1}
      >
        <div className={styles.container}>
          {!isForcedLock && (
            <IconButton
              icon={<IconX />}
              label={TEXT.iconLabel}
              onClick={onClose}
              size="small"
              style={{
                position: 'absolute',
                right: theme.spaces[16],
                top: theme.spaces[16],
              }}
              variant="link"
            />
          )}
          <AccountLockingDialogContent isShare={isShare} onClose={onClose} />
        </div>
      </Dialog>
    </ThemeProvider>
  );
};
